import { render, staticRenderFns } from "./TableInformationAbs.vue?vue&type=template&id=16a18044"
import script from "./TableInformationAbs.vue?vue&type=script&lang=js"
export * from "./TableInformationAbs.vue?vue&type=script&lang=js"
import style0 from "./TableInformationAbs.vue?vue&type=style&index=0&id=16a18044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports